import * as React from "react";
const SvgFiRrLocationDotSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-location-dot-slash_svg__a)">
      <path
        fill="#062147"
        d="M16.635 20.321a1 1 0 0 1-.056 1.413l-.793.732A5.4 5.4 0 0 1 12 24a5.42 5.42 0 0 1-3.807-1.553L4.25 18.804C1.315 15.871.273 11.626 1.504 7.701a1 1 0 1 1 1.908.598 8.98 8.98 0 0 0 2.224 9.065l3.935 3.634c1.337 1.307 3.542 1.287 4.837.02l.813-.752a1 1 0 0 1 1.413.056zm7.072 3.386a.997.997 0 0 1-1.414 0l-22-22A.999.999 0 1 1 1.707.293l2.725 2.725A10.92 10.92 0 0 1 12 0c2.938 0 5.7 1.145 7.778 3.222 4.22 4.22 4.288 11.043.204 15.347l3.725 3.725a1 1 0 0 1 0 1.413M5.847 4.432l3.54 3.54A4 4 0 0 1 12 7a4.004 4.004 0 0 1 3.03 6.615l3.538 3.54c3.303-3.498 3.244-9.07-.205-12.52A8.95 8.95 0 0 0 12 2a8.94 8.94 0 0 0-6.154 2.432zm7.76 7.761A2.002 2.002 0 0 0 12 9c-.432 0-.85.141-1.19.395l2.798 2.8z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-location-dot-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLocationDotSlash;
